import { SET_SHOULD_PORTAL_PRICING } from '../actions/types';

const initialState = false;

export default function shouldPortalPricing(state = initialState, action) {
	if (action.payload !== undefined) {
		switch (action.type) {
			case SET_SHOULD_PORTAL_PRICING:
				return action.payload;
			default:
		}
	}
	return state;
}
